// extracted by mini-css-extract-plugin
export var button = "TechnologiesGrid-module--button--c69c7";
export var buttonRow = "TechnologiesGrid-module--buttonRow--7931a";
export var container = "TechnologiesGrid-module--container--c3c88";
export var containerWithTabs = "TechnologiesGrid-module--containerWithTabs--422af";
export var contentSubtitle = "TechnologiesGrid-module--contentSubtitle--a3d4b";
export var desktopContent = "TechnologiesGrid-module--desktopContent--225d7";
export var expandPanelContent = "TechnologiesGrid-module--expandPanelContent--2f11a";
export var fadeInAnimation = "TechnologiesGrid-module--fadeInAnimation--41512";
export var infoBlock = "TechnologiesGrid-module--infoBlock--44233";
export var link = "TechnologiesGrid-module--link--43d5b";
export var list = "TechnologiesGrid-module--list--d7dc5";
export var listTitle = "TechnologiesGrid-module--listTitle--943f4";
export var mobileContent = "TechnologiesGrid-module--mobileContent--8dd0e";
export var singleTabList = "TechnologiesGrid-module--singleTabList--d998f";
export var tab = "TechnologiesGrid-module--tab--28616";
export var tabContent = "TechnologiesGrid-module--tabContent--589b6";
export var tabsRow = "TechnologiesGrid-module--tabsRow--de7d1";
export var tilesWrapper = "TechnologiesGrid-module--tilesWrapper--7d787";
export var title = "TechnologiesGrid-module--title--ced3d";
export var tools = "TechnologiesGrid-module--tools--170c7";
export var wrapper = "TechnologiesGrid-module--wrapper--4f21e";